// 「読み込み中…」の統一表示。aria-live で読み上げにも配慮。
interface Props {
  label?: string;
  className?: string;
}

export function Loading({ label = "読み込み中…", className }: Props) {
  return (
    <p
      className={`text-sm text-tora-ink/60 ${className ?? ""}`.trim()}
      role="status"
      aria-live="polite"
    >
      {label}
    </p>
  );
}
